// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2lF-C","range":"MonthRangeSwitch_range__1TvuU","disabled":"MonthRangeSwitch_disabled__3GgcW"};